<template>
  <v-container class="app-container--width-max">
    <StepperBase :sections="allSectionsEdited" />
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import StepperBase from "@/components/Steppers/StepperBase";
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";
export default {
  name: "QuotationMain",
  components: {
    StepperBase,
  },
  created() {
    EventBus.$on("validation-error", handleValidationError);
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["allSectionsEdited"]),
    ...mapState(QUESTIONS_MODULE, ["form"]),
  },
  methods: {
    showStepper() {
      // If CoverType question hasn't been answered, go to root url to answer it
      const questionAnswered = this.form.sections[0].Questions[0].Value === "";
      if (questionAnswered) {
        this.$router.push("/");
      }
    },
  },
  updated() {
    this.showStepper();
  },
  beforeDestroy() {
    EventBus.$off("validation-error"); // Clean up the event listener
  },
};
</script>
